import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    component: Home,
    icon: "el-icon-s-home",
    meta: {
      title: "首页",
      funcKey: "",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/index/index"),
        meta: {
          title: "首页",
          funcKey: "",
        },
      },
    ],
  },
  {
    path: "/customer-manage",
    component: Home,
    icon: "icon-menuicon06",
    meta: {
      title: "客户报备",
      funcKey: "KHBB",
    },
    children: [
      {
        name: "customer-manage",
        path: "/customer-manage",
        component: () => import("../views/customer-manage/customer/customer-manage"),
        meta: {
          title: "客户报备",
          funcKey: "KHBBCD",
        },
      },
      {
        path: "/report-log",
        component: () => import("../views/customer-manage/report-log/report-log"),
        meta: {
          title: "报备记录",
          funcKey: "",
        },
      },
      {
        path: "/add-customer",
        name: "add-customer",
        component: () => import("@/views/customer-manage/customer/add-customer"),
        meta: {
          title: "添加客户",
          funcKey: "KHXJ",
          isInfo: true,
        },
      },
      {
        path: "/public-customer",
        component: () => import("../views/customer-manage/public-customer/public-customer"),
        meta: {
          title: "公海",
          funcKey: "KHGH",
        },
      },
      {
        path: "/customer-detail",
        component: () => import("../views/customer-manage/customer/customer-detail"),
        meta: {
          title: "客户详情",
          funcKey: "KHBB",
          isInfo: true,
        },
      },
      {
        path: "/nearby-residents",
        component: () => import("../views/customer-manage/nearby-customer/nearby-customer"),
        meta: {
          title: "附近客户",
          funcKey: "FJKH",
        },
      },
    ],
  },
  {
    path: "/contact",
    component: Home,
    icon: "el-icon-s-custom",
    meta: {
      title: "联系人管理",
      funcKey: "LXRGL",
    },
    children: [
      {
        path: "",
        component: () => import("../views/contact/contact-manage.vue"),
        meta: {
          title: "联系人管理",
          funcKey: "LXRGLCD",
        },
      },
    ],
  },
  {
    path: "/contract-manage",
    component: Home,
    icon: "el-icon-s-management",
    meta: {
      title: "合同管理",
      funcKey: "HTGL",
    },
    children: [
      {
        name: "contract-manage",
        path: "/contract-manage",
        component: () => import("../views/contract-manage/contract-manage"),
        meta: {
          title: "合同管理",
          funcKey: "HTGLCD",
        },
      },
      {
        name: "contract-audit",
        path: "/contract-audit",
        component: () => import("../views/contract-manage/contract-audit.vue"),
        meta: {
          title: "合同审核",
          funcKey: "",
        },
      },
      {
        name: "receipt-audit",
        path: "/receipt-audit",
        component: () => import("../views/contract-manage/receipt-audit.vue"),
        meta: {
          title: "回款审核",
          funcKey: "",
        },
      },
      {
        path: "/add-contract",
        name: "add-contract",
        component: () => import("@/views/contract-manage/add-contract"),
        meta: {
          title: "新建合同",
          funcKey: "HTXZ",
          isInfo: true,
        },
      },
      {
        path: "/approval-info",
        name: "approval-info",
        component: () => import("@/views/work-flow/approval/info"),
        meta: {
          title: "审核详情",
          funcKey: "HTGLCD",
          isInfo: true,
        },
      },
      {
        path: "/contract-detail",
        name: "合同详情",
        component: () => import("../views/contract-manage/contract-detail"),
        meta: {
          title: "合同详情",
          funcKey: "HTGLCD",
          isInfo: true,
        },
      },
    ],
  },
  {
    path: "/system",
    component: Home,
    redirect: "/org",
    icon: "icon-menuicon07",
    meta: {
      title: "系统管理",
      funcKey: "XTSZ",
    },
    children: [
      {
        path: "/org",
        component: () => import("../views/org/index"),
        meta: {
          title: "组织架构",
          funcKey: "ZZJG",
        },
      },
      {
        path: "/role",
        component: () => import("../views/role/Role"),
        meta: {
          title: "角色管理",
          funcKey: "JSGL",
        },
      },
      {
        path: "/rule-setting",
        component: () => import("../views/rule"),
        meta: {
          title: "规则设置",
          funcKey: "GZSZ",
        },
      },
      {
        path: "/dictionary-manage",
        component: () => import("../views/system-set/dictionary-manage/dictionary-manage"),
        meta: {
          title: "字典管理",
          funcKey: "ZDGL",
        },
      },
      {
        path: "/workflow-manage",
        component: () => import("../views/work-flow/approval-manage/manage"),
        meta: {
          title: "审批管理",
          funcKey: "",
        },
      },
      {
        path: "/workflow-define",
        component: () => import("../views/work-flow/process/define"),
        meta: {
          title: "审批设置",
          funcKey: "",
          isInfo: true,
        },
      }
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
